module.exports = __webpack_public_path__ + "img/weddings_28_V.214aea23.webp";